import { render, staticRenderFns } from "./PublisherSetupTabFilter.vue?vue&type=template&id=71b290d0&"
import script from "./PublisherSetupTabFilter.vue?vue&type=script&lang=js&"
export * from "./PublisherSetupTabFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VList})
